<template>
  <login-layout :title="layoutTit">
    <dl class="bind-login-tit">
      <dt>{{ $t('message["724"]') }}</dt>
      <dd>{{ $t('message["831"]') }}</dd>
    </dl>
    <div class="accout-login">
      <a-form
        :form="form"
        @submit.prevent="submitForm"
      >
        <a-form-item
          label=""
        >
          <a-input
            v-decorator="decorators.username"
            :placeholder="accountTitTxt"
          />
        </a-form-item>
        <a-form-item
          label=""
          class="password-box"
        >
          <a-input
            v-decorator="decorators.password"
            placeholder="密码"
            type="password"
            class="password-input"
          />
          <router-link
            :to="{ name: 'AccountFindPwd' }"
            class="find-pwd-link"
          >
            {{ $t('message["1573"]') }}
          </router-link>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["13"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </login-layout>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import LoginLayout from '@/components/pc/account/LoginLayout'
import { setAuth } from '@/lib/storage'

export default {
  'name': 'BindLogin',
  components: {
    LoginLayout
  },
  props: {
    weworkuserinfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      bindLogin: {
        username: '',
        password: '',
        weworkuserinfo: {}
      }
    }
  },
  computed: {
    ...mapState('account/login', ['submitting', 'decorators']),
    accountTitTxt () {
      return this.$t('message["450"]')
    },
    layoutTit () {
      return this.$t('message["1381"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/login', ['QwDdBindAjax']),
    submitForm (formName) {
      // this.$refs[formName].validate(async (valid) => {
      //   if (valid) {
      //     this.bindLogin.weworkuserinfo = this.weworkuserinfo
      //     let res = await this.QwDdBindAjax(this.bindLogin)
      //     if (!res.error) {
      //       await this.$store.dispatch('login', res.payload.Authorization)
      //       this.$router.push({ name: 'AccountInfo' })
      //     }
      //   } else {
      //     return false
      //   }
      // })
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, { weworkuserinfo: this.weworkuserinfo })
          const chain = await this.QwDdBindAjax()
          chain.params(obj)
            .onSuccess(res => {
              setAuth(res.Authorization)
              this.$store.commit('setAuth', res.Authorization)
              this.$router.push({ name: 'AccountInfo' })
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.bind-login-tit {
  text-align: center;
  margin-top: 30px;
  line-height: 24px;

  dt {
    font-size: 14px;
    font-weight: bold;
  }

  dd {
    font-size: 12px;
    color: #b3b3b3;
    padding: 10px 0 20px;
  }
}

.accout-login {
  .login-btn {
    display: block;
    width: 100%;
  }

  .password-box {
    position: relative;

    .find-pwd-link {
      position: absolute;
      right: 12px;
    }
  }
}
</style>
